
import { useState, useEffect } from 'react';

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Function to check if device is mobile
    const checkMobile = () => {
      const userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
      const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      const isMobileByUserAgent = mobileRegex.test(userAgent);
      
      // Also check screen width for responsive designs
      const isMobileByScreenSize = window.innerWidth < 768;
      
      console.info('Mobile detection check:', {
        userAgent: isMobileByUserAgent,
        screenSize: isMobileByScreenSize,
        width: window.innerWidth
      });
      
      return isMobileByUserAgent || isMobileByScreenSize;
    };

    const handleResize = () => {
      const mobileCheck = checkMobile();
      console.info('Resize detected, setting isMobile to:', mobileCheck);
      setIsMobile(mobileCheck);
    };

    // Set initial value
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);
    
    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
};
